import React from "react";
import { Modal } from "react-bootstrap";
import Login from "../web-pages/auth/Login";
import Register from "../web-pages/auth/Register";

const AuthModal = ({
  formToShow,
  setFormToShow,
  modalClose,
  show,
  stayOnPage = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={modalClose}
      dialogClassName="modal-width"
      centered
      enforceFocus={false}
    >
      <Modal.Body
        style={{
          padding: "0px",
          background: "transparent",
          position: "relative",
        }}
      >
        {formToShow === "login" ? (
          <Login
            modalClose={modalClose}
            setFormToShow={setFormToShow}
            stayOnPage={stayOnPage}
          />
        ) : (
          <Register modalClose={modalClose} setFormToShow={setFormToShow} />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AuthModal;
